

import React, { Component } from 'react';
import ReactDOM from "react-dom";
import { Map, GoogleApiWrapper } from 'google-maps-react';


import OhlFirstLevel from './components/ohlLayers/ohlElements/ohlFirstLevel';
import StationsElement from './components/ohlLayers/ohlElements/stations';
import PhaseCrossesElement from './components/ohlLayers/ohlElements/phaseCross';
import PortalsElement from './components/ohlLayers/ohlElements/portal';
import HealthInexMap from './components/ohlLayers/healthIndexesLayer/healthIndexMap';
import ThunderStrikesMap from './components/ohlLayers/outageLayer/thunderStrikesMap';
import SelectedPortals from './components/ohlLayers/ohlElements/selectedPortals';
import OhlLightningStrikeHits from './components/ohlLayers/outageLayer/ohlLightningStrikeHits';
import OhlLightningStrikesAffectedSections from './components/ohlLayers/outageLayer/ohlLightningStrikeAffectedSections';
import InfoWindowElement from './components/InfoWindow/infoWindow';
import PruningIcon from './components/ohlLayers/pruningLayer/pruningIcon';
import PruningAreas from './components/ohlLayers/pruningLayer/pruningArea';
import PruningParcel from './components/ohlLayers/pruningLayer/pruningParcel';
import UndergroundObjects from './components/ohlLayers/undergroundObjectsLayer/undergroundObject';
import CountryBorder from './components/ohlLayers/countryBorder';
import PolesElement from './components/ohlLayers/ohlElements/pole';
import ProtectionWireElement from './components/ohlLayers/ohlElements/protectionWire';
import SelectedOhlsElement from './components/ohlLayers/ohlElements/selectedOhls';
import PhasesElement from './components/ohlLayers/ohlElements/phase';
import SpansElement from './components/ohlLayers/ohlElements/span';

import * as serbiCoordinates from './sources/borders/state/serbia';


const phaseCrossColor = '#ffff00';


export class MapContaner extends Component {

    thunderStorm = null;

    constructor(props) {
        super(props);

        this.state = {

            zoom: 10,
            healthIndexesMapElement: null,
            ohlFirstLevelList: [],
            stationsList: [],
            portalElementsList: [],
            selectedPortalsElements: [],
            ohlLightingStrikes: [],
            ohlLightningAffectedAreasList: [],
            phaseCrossesListElement: [],
            thunderStormMap: null,
            infoWindowElement: null,
            pruningIconsList: [],
            pruningAreasList: [],
            pruningParcelssList: [],
            undergroundObjectsList: [],
            countryBorder: [],
            polesList: [],
            protectionWiresList: [],
            selectedOhlsElements: [],
            phaseElements: [],
            spanElements: []
        };
    }

    componentWillReceiveProps (newProps) {
        if(newProps.zoomLevel !== this.props.zoomLevel) {
            this.setState({
                bounds: []
            });
        };
    }

    onInfoWindowOpen() {
        ReactDOM.render(
          React.Children.only(this.props.selectedPlace),
          document.getElementById("infoWindowElement")
        );
    }

    onTilesLoaded = (props, googleMap) => {
        //const bounds = map.getBounds();
        const mapMargin = 0.005;
        //const bounds = map.getBounds();
        //const boundsProperties = Object.getOwnPropertyNames(bounds);

        const zoom = googleMap.zoom;
        const mapBoundsProperties = Object.getOwnPropertyNames(googleMap.getBounds());
        const cornerProperties = Object.getOwnPropertyNames(googleMap.getBounds()[mapBoundsProperties[0]])

        if(cornerProperties && cornerProperties.length > 0){
            
            // let latMin = bounds.Ya.g - margin;
            // let latMax = bounds.Ya.i + margin;
            // let lngMin = bounds.Ta.g - margin;
            // let lngMax = bounds.Ta.i + margin;

            const latMin = googleMap.getBounds()[mapBoundsProperties[0]][cornerProperties[0]] - mapMargin;
            const latMax = googleMap.getBounds()[mapBoundsProperties[0]][cornerProperties[1]] + mapMargin;
            const lngMin = googleMap.getBounds()[mapBoundsProperties[1]][cornerProperties[0]] - mapMargin;
            const lngMax = googleMap.getBounds()[mapBoundsProperties[1]][cornerProperties[1]] + mapMargin;

            this.setState({
                bounds: { latMin: latMin, latMax: latMax, lngMin: lngMin, lngMax: lngMax }
            });
            if(!this.props.isLoaded){
                ////NOTE: try it with ref instead
                this.props.setMap(googleMap);
            }
        }
    }


    sendChildElementDataToState = (stateName, value) => {
        this.setState({
            [stateName]: value
        });
        this.props.setMapAsEdited();
    }

    render() {

        let poleSize = this.props.showLargeIcons ? 50 : 30;

        return (
            <Map
                id='googleMapElement55555'
                google={this.props.google}
                zoom={this.state.zoom}
                initialCenter={{
                    lat: 44.789371, lng: 20.235146
                }}
                bounds={this.props.mapBounds}
                center={this.props.mapCenter}
                onTilesloaded={this.onTilesLoaded}
                onZoom_changed={this.props.onZoomChanged}
                onClick={this.props.onMapClick}
                onRightclick={this.props.onRightClick}
                minZoom={5}
            >


                {this.state.selectedOhlsElements}
                {this.state.ohlFirstLevelList}
                {this.state.phaseCrossesListElement}
                {this.state.stationsList}
                {this.state.portalElementsList}
                {this.state.selectedPortalsElements}
                {this.state.thunderStormMap}
                {this.state.ohlLightingStrikes}
                {this.state.ohlLightningAffectedAreasList}
                {this.state.healthIndexesMapElement}
                {this.state.pruningIconsList}
                {this.state.pruningParcelssList}
                {this.state.pruningAreasList}

                {this.state.undergroundObjectsList}
                {this.state.countryBorder}
                {this.state.polesList}
                {this.state.protectionWiresList}
                {this.state.phaseElements}
                {this.state.spanElements}
                {this.state.infoWindowElement}



                <OhlFirstLevel
                    ohlsList={this.props.ohlList}
                    zoomLevel={this.props.zoomLevel}
                    showDividedSpans={this.props.showDividedSpans}
                    color35={this.props.color35}
                    color110={this.props.color110}
                    color220={this.props.color220}
                    color400={this.props.color400}
                    ohlThickness={this.props.ohlThickness}
                    onSegmentClick={this.props.onSegmentClick}
                    onOhlClick={this.props.onOhlClick}
                    stateElementName= 'ohlFirstLevelList'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                />

                {/* <InfoWindow
                    marker={this.props.activeMarker ? this.props.activeMarker : null}
                    position={this.props.activeMarker == null ? this.props.infoWindowPosition : null}
                    visible={this.props.showingInfoWindow}
                    onOpen={e => {
                        this.onInfoWindowOpen(this.props, e);
                    }}
                >
                <div id="infoWindowElement" />
                </InfoWindow> */}

                <StationsElement
                    ohlsList={this.props.ohlList}
                    showStations={this.props.showStations}
                    zoomLevel={this.props.zoomLevel}
                    onStationClick={this.props.onStationClick}
                    stateElementName= 'stationsList'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                />
                <PortalsElement
                    ohlsList={this.props.ohlList}
                    showPortalsAlways={this.props.showPortalsAlways}
                    poleSize={poleSize}
                    showHealthIndexes={this.props.showHealthIndexes}
                    zoomLevel={this.props.zoomLevel}
                    onPortalClick={this.props.onPortalClick}
                    stateElementName= 'portalElementsList'
                    sendChildElementDataToState={this.sendChildElementDataToState}

                />
                <SelectedPortals
                    showPortalsOnlyForSelectedOHL={this.props.showPortalsOnlyForSelectedOHL}
                    selectedOHLs={this.props.selectedOHLs}
                    zoomLevel={this.props.zoomLevel}
                    onPortalClick={this.props.onPortalClick}
                    stateElementName= 'selectedPortalsElements'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                />

                <ThunderStrikesMap
                    positions={this.props.thunderStrikesList}
                    showOutageLayer={this.props.showOutageLayer}
                    showThunderStormEffects={this.props.showThunderStormEffects}
                    showAllThunderHits={this.props.showAllThunderHits}
                    showThunderMap={this.props.showThunderMap}
                    stateElementName= 'thunderStormMap'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                />
                <OhlLightningStrikeHits
                    ohlLightningStrikesList={this.props.ohlLightningStrikesList}
                    showOutageLayer={this.props.showOutageLayer}
                    showOhlThunderHitIcons={this.props.showOhlThunderHitIcons}
                    onOutageHitClick={this.props.onOutageHitClick}
                    onOhlThunderHitClick={this.props.onOhlThunderHitClick}
                    stateElementName= 'ohlLightingStrikes'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                />
                <OhlLightningStrikesAffectedSections
                    ohlLightningAffectedAreasList={this.props.ohlLightningAffectedAreasList}
                    showOutageLayer={this.props.showOutageLayer}
                    showAffectedOhlSections={this.props.showAffectedOhlSections}
                    stateElementName= 'ohlLightningAffectedAreasList'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                />

                <HealthInexMap
                    ohlsList={this.props.ohlList}
                    //healthIndexPositionsList={healtyIndexPositionsList}
                    showHealthIndexes={this.props.showHealthIndexes}
                    stateElementName='healthIndexesMapElement'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                />
                <PhaseCrossesElement
                    ohlsList={this.props.ohlList}
                    zoomLevel={this.props.zoomLevel}
                    showPhaseCross={this.props.showPhaseCross}
                    onPhaseCrossClick={this.props.onPhaseCrossClick}
                    stateElementName= 'phaseCrossesListElement'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                />

                <PruningIcon 
                    pruningList={this.props.pruningList}
                    showPruningLayer={this.props.showPruningLayer}
                    showPruningIcons={this.props.showPruningIcons}
                    zoomLevel={this.props.zoomLevel}
                    poleSize={poleSize}
                    onPruningClick={this.props.onPruningClick}
                    stateElementName= 'pruningIconsList'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                />
                <PruningAreas 
                    pruningList={this.props.pruningList}
                    showPruningLayer={this.props.showPruningLayer}
                    zoomLevel={this.props.zoomLevel}
                    onPruningClick={this.props.onPruningClick}
                    stateElementName= 'pruningAreasList'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                    
                />
                <PruningParcel 
                    pruningList={this.props.pruningList}
                    showPruningLayer={this.props.showPruningLayer}
                    showPruningParcels={this.props.showPruningParcels}
                    zoomLevel={this.props.zoomLevel}
                    onPruningPlaceClick={this.props.onPruningPlaceClick}
                    stateElementName= 'pruningParcelssList'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                />
                <UndergroundObjects 
                    undergroundObjectsList={this.props.undergroundObjectsList}
                    showUndergrounObjectsLayer={this.props.showUndergrounObjectsLayer}
                    onUndergroundObjectClick={this.props.onUndergroundObjectClick}
                    ohlThickess={3}
                    stateElementName='undergroundObjectsList'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                />
                <CountryBorder 
                    borderPath={serbiCoordinates.border}
                    showCountryBorder={this.props.showCountryBorder}
                    stateElementName='countryBorder'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                />
                <PolesElement 
                    ohlsList={this.props.ohlList}
                    zoomLevel={this.props.zoomLevel}
                    bounds={this.state.bounds}
                    showHealthIndexes={this.props.showHealthIndexes}
                    poleSize={poleSize}
                    onPoleClick={this.props.onPoleClick}
                    isOhlListEdited={this.props.isOhlListEdited}
                    stateElementName='polesList'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                />
                <ProtectionWireElement 
                    ohlsList={this.props.ohlList}
                    showThirdLevel={this.props.showThirdLevel}
                    zoomLevel={this.props.zoomLevel}
                    bounds={this.state.bounds}
                    onWireClick={this.props.onWireClick}
                    stateElementName='protectionWiresList'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                />
                <SelectedOhlsElement
                    selectedOHLs={this.props.selectedOHLs}
                    zoomLevel={this.props.zoomLevel}
                    color110={this.props.color110}
                    stateElementName='selectedOhlsElements'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                />
                <PhasesElement 
                    ohlsList={this.props.ohlList}
                    zoomLevel={this.props.zoomLevel}
                    bounds={this.state.bounds}
                    onPhaseClick={this.props.onPhaseClick}
                    stateElementName='phaseElements'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                />
                <SpansElement 
                    ohlsList={this.props.ohlList}
                    zoomLevel={this.props.zoomLevel}
                    bounds={this.state.bounds}
                    isOhlListEdited={this.props.isOhlListEdited}
                    color35={this.props.color35}
                    color110={this.props.color110}
                    color220={this.props.color220}
                    color400={this.props.color400}
                    phaseCrossColor={phaseCrossColor}
                    onSpanClick={this.props.onSpanClick}
                    stateElementName='spanElements'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                />

                <InfoWindowElement
                    activeMarker={this.props.activeMarker}
                    infoWindowPosition={this.props.infoWindowPosition}
                    getInfoWindowElement={this.getInfoWindowElement}
                    showingInfoWindow={this.props.showingInfoWindow}
                    selectedPlace={this.props.selectedPlace}
                    selectedPlaceName={this.props.selectedPlaceName}
                    stateElementName='infoWindowElement'
                    sendChildElementDataToState={this.sendChildElementDataToState}
                />
            </Map >
        );
    }
}


export default GoogleApiWrapper({
    apiKey: 'AIzaSyCRdeV41Zt7I-9Rx95KF9lJ4_xR0nrcvng',
    libraries: ["visualization"]
})(MapContaner);